var Curriculog = Curriculog || {};

Curriculog.CurriculogCollection = (function ($, _, Backbone, CurriculogCollection) {

	CurriculogCollection = Backbone.Collection.extend({
		showGrowl: function (message) {
			$('#growls').notify('create', 'warning-template', {
				text: message
			});
		},
	});
	return CurriculogCollection;

})($, _, Backbone, Curriculog.CurriculogCollection || {});
